import { Switch, Tag } from '@bfe/moly';
import { useEffect, useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import { getVipNoticeStatus, setVipNoticeStatus } from '@/services/vipNotice';
import { VipNoticeStatus } from '@/utils/pageConfig/settings/vipNotice';

const VipNotice = () => {
  const [$t] = useI18nContext();
  const [loading, setLoading] = useState(true);
  const [checked, setChecked] = useState(false);

  const onSwitch = (checked: boolean) => {
    setLoading(true);
    setVipNoticeStatus(checked ? VipNoticeStatus.YES : VipNoticeStatus.NO)
      .then(() => {
        setChecked(checked);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getVipNoticeStatus()
      .then((res) => {
        setChecked(res?.result === VipNoticeStatus.YES);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="vip-notice">
      <div className="vip-notice__container">
        <div className="vip-notice__label">
          <div className="vip-notice__title">
            {$t('vipNoticeTitle')}
            <Tag variant="vip-only" size="normal" color="vip-black">
              VIP Only
            </Tag>
          </div>
          <div className="vip-notice__desc">{$t('vipNoticeDesc')}</div>
        </div>
        <Switch
          loading={loading}
          checked={checked}
          onCheckedChange={(checked: boolean) => onSwitch(checked)}
        />
      </div>
    </div>
  );
};

export default VipNotice;
